import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Message from '@prism/message';

class PrismMessage extends React.PureComponent {
    static propTypes = {
        color: PropTypes.string,
        className: PropTypes.string,
        messageClassName: PropTypes.string,
        title: PropTypes.string,
        isOpen: PropTypes.bool,
        fade: PropTypes.bool
    };

    static defaultProps = {
        color: 'info',
        isOpen: true,
        fade: true
    };
    
    componentDidMount() {
        if (this.props.initialize) {
            this.props.initialize();
        }
    };

    render() {
        const containerClassName = classNames(
            'prism-sandbox',
            this.props.className
        );

        return (
            <div className={containerClassName}>
                <Message
                    {...this.props}
                    className={this.props.messageClassName}
                >
                    {this.props.children}
                </Message>
            </div>
        );
    }
}

export default PrismMessage;
